

export const imagesAndIcons = {

    decapayIcon: require('../src/assets/icons/Pay.png'),
}